/* eslint-disable */
/*!
  _   _  ___  ____  ___ ________  _   _   _   _ ___   
 | | | |/ _ \|  _ \|_ _|__  / _ \| \ | | | | | |_ _| 
 | |_| | | | | |_) || |  / / | | |  \| | | | | || | 
 |  _  | |_| |  _ < | | / /| |_| | |\  | | |_| || |
 |_| |_|\___/|_| \_\___/____\___/|_| \_|  \___/|___|
                                                                                                                                                                                                                                                                                                                                       
=========================================================
* Horizon UI - v1.1.0
=========================================================

* Product Page: https://www.horizon-ui.com/
* Copyright 2022 Horizon UI (https://www.horizon-ui.com/)

* Designed and Coded by Simmmple

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import React, { useEffect } from "react";
import { GoogleLogin } from '@react-oauth/google';

function SignIn() {
  const [redirectAfterLogin, setRedirectAfterLogin] = React.useState(false);

  // Extract URL parameter
  const queryString = window.location.hash.substring(
    window.location.hash.indexOf("?") + 1
  );
  const params = new URLSearchParams(queryString);
  const joinParam = params.get("join") || ""; // Get 'join' param or default to empty string

  useEffect(() => {
    if (redirectAfterLogin) {
      // Append the join parameter to the redirect URL if it exists
      const redirectUrl = joinParam
        ? `/#/admin/dashboard?join=${joinParam}`
        : "/#/admin/dashboard";
      window.location.replace(redirectUrl);
    }
  }, [redirectAfterLogin, joinParam]);

  const responseMessage = (response: any) => {
    localStorage.setItem('jwtToken', response.credential);
    setRedirectAfterLogin(true);
  };

  return (
    <div className="font-display bg-[#050A14] text-white min-h-screen overflow-hidden flex flex-col items-center justify-between relative selection:bg-electric-blue selection:text-white"
      style={{ fontFamily: "'Space Grotesk', sans-serif" }}
    >
      {/* Background Elements */}
      <div
        className="absolute inset-0 z-0 pointer-events-none opacity-60 mix-blend-screen"
        style={{ background: "radial-gradient(circle at center, #137FEC 0%, #0A1929 40%, #050A14 70%)" }}
      ></div>
      <div
        className="absolute inset-0 z-0 opacity-30 pointer-events-none mix-blend-overlay"
        style={{
          backgroundImage: "linear-gradient(to right, #1f2937 1px, transparent 1px), linear-gradient(to bottom, #1f2937 1px, transparent 1px)",
          backgroundSize: "40px 40px",
          maskImage: "linear-gradient(to bottom, transparent, 10%, black, 90%, transparent)",
          WebkitMaskImage: "linear-gradient(to bottom, transparent, 5%, black, 80%, transparent)"
        }}
      ></div>
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none z-0">
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[80%] h-[40%] bg-[#137FEC]/20 rounded-full blur-[100px]"></div>
      </div>

      {/* Main Content */}
      <main className="flex-1 w-full flex flex-col items-center justify-center relative z-10 px-6 py-10">
        <div className="flex items-center justify-center gap-4 relative animate-[fadeIn_1s_ease-out]">
          <div className="absolute inset-0 bg-[#137FEC] blur-[60px] opacity-40 rounded-full z-[-1]"></div>
          <div className="w-8 h-8 rounded-full bg-[#137FEC]"></div>
          <h1 className="text-5xl font-bold tracking-tight text-white">Sprint</h1>
        </div>
      </main>

      {/* Footer / CTA */}
      <footer className="w-full px-6 pb-12 z-20">
        <div className="flex flex-col items-center gap-6">
          <div className="relative w-full max-w-sm h-14">
            {/* Visual Button */}
            <div
              className="absolute inset-0 group w-full h-full bg-[#137FEC] rounded-full overflow-hidden shadow-[0_0_40px_-10px_rgba(19,127,236,0.6)] hover:shadow-[0_0_60px_-10px_rgba(19,127,236,0.8)] transition-all duration-300 active:scale-95 flex items-center justify-center pointer-events-none"
            >
              <div className="absolute inset-0 bg-gradient-to-b from-white/20 to-transparent opacity-50"></div>
              <div className="relative flex items-center justify-center gap-2 h-full px-6">
                <span className="text-white text-base font-bold tracking-wide group-hover:tracking-wider transition-all duration-300">
                  Ingresar o Registrarse
                </span>
              </div>
            </div>

            {/* Hidden Google Login Button Overlay */}
            {/* Hidden Google Login Button Overlay */}
            <div className="absolute inset-0 z-[100] opacity-[0.01] flex items-center justify-center overflow-visible">
              <div style={{ transform: 'scale(4)', width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <GoogleLogin
                  onSuccess={responseMessage}
                  onError={() => console.log('Login Failed')}
                  width="380"
                  theme="filled_blue"
                  size="large"
                  text="signup_with"
                  shape="circle"
                />
              </div>
            </div>
          </div>

          <p className="text-xs text-white/40 font-medium tracking-wide">
            Experience digital dollar payments
          </p>
        </div>
      </footer>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}

export default SignIn;
